import React, { useState, useEffect } from 'react';
import api from './api';

const BrokerLedger = () => {
    const [brokers, setBrokers] = useState([]);
    const [selectedBroker, setSelectedBroker] = useState(null);
    const [details, setDetails] = useState({ lots: [], payments: [] });
    
    // Payment Modal
    const [showPayModal, setShowPayModal] = useState(false);
    const [payForm, setPayForm] = useState({ amount: '', mode: 'Cheque', note: '' });

    // 1. Load Broker List
    const fetchBrokers = async () => {
        const res = await api.get('/broker-ledger');
        setBrokers(res.data);
    };

    useEffect(() => { fetchBrokers(); }, []);

    // 2. Load Details when a Broker is clicked
    const handleBrokerClick = async (broker) => {
        setSelectedBroker(broker);
        const res = await api.get(`/broker-ledger/${broker._id}`);
        setDetails(res.data);
    };

    // 3. Submit Payment
    const handlePayment = async (e) => {
        e.preventDefault();
        try {
            await api.post('/broker-ledger/pay', {
                brokerId: selectedBroker._id,
                ...payForm
            });
            alert("✅ Payment Recorded!");
            setShowPayModal(false);
            setPayForm({ amount: '', mode: 'Cheque', note: '' });
            
            // Refresh Data
            fetchBrokers();
            handleBrokerClick(selectedBroker); 
        } catch (err) { alert("Error"); }
    };

    return (
        <div className="container mt-4 mb-5">
            <h4 className="fw-bold mb-4">Broker Ledger</h4>

            <div className="row h-100">
                
                {/* LEFT: BROKER LIST */}
                <div className="col-md-4 mb-3">
                    <div className="list-group shadow-sm">
                        {brokers.map(b => (
                            <button 
                                key={b._id} 
                                className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${selectedBroker?._id === b._id ? 'active' : ''}`}
                                onClick={() => handleBrokerClick(b)}
                            >
                                <div>
                                    <div className="fw-bold">{b.name}</div>
                                    <small className={selectedBroker?._id === b._id ? 'text-light' : 'text-muted'}>
                                        {b.lotCount} Lots
                                    </small>
                                </div>
                                <div className="text-end">
                                    <div className="fw-bold">₹ {Math.round(b.balance).toLocaleString()}</div>
                                    <small style={{fontSize:'0.7rem'}}>Due</small>
                                </div>
                            </button>
                        ))}
                    </div>
                </div>

                {/* RIGHT: DETAILS VIEW */}
                <div className="col-md-8">
                    {selectedBroker ? (
                        <div className="card shadow-sm border-0">
                            <div className="card-header bg-white d-flex justify-content-between align-items-center py-3">
                                <div>
                                    <h5 className="mb-0 fw-bold">{selectedBroker.name}</h5>
                                    <span className="text-muted small">Total Pending: </span>
                                    <span className="text-danger fw-bold">₹ {Math.round(selectedBroker.balance).toLocaleString()}</span>
                                </div>
                                <button className="btn btn-success btn-sm" onClick={() => setShowPayModal(true)}>
                                    Pay Broker
                                </button>
                            </div>
                            
                            <div className="card-body p-0">
                                {/* TABS (Simple) */}
                                <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
                                    <li className="nav-item"><a className="nav-link active" data-bs-toggle="tab" href="#lots">Commission Sources (Credit)</a></li>
                                    <li className="nav-item"><a className="nav-link" data-bs-toggle="tab" href="#payments">Payment History (Debit)</a></li>
                                </ul>

                                <div className="tab-content p-3" style={{height:'400px', overflowY:'auto'}}>
                                    {/* TAB 1: LOTS */}
                                    <div className="tab-pane fade show active" id="lots">
                                        <table className="table table-sm table-hover small">
                                            <thead className="table-light"><tr><th>Date</th><th>Lot No</th><th>Net Amt</th><th>%</th><th className="text-end">Comm. (₹)</th></tr></thead>
                                            <tbody>
                                                {details.lots.map(lot => (
                                                    <tr key={lot._id}>
                                                        <td>{new Date(lot.purchaseDate).toLocaleDateString('en-GB')}</td>
                                                        <td className="fw-bold">{lot.rpNumber}</td>
                                                        <td>{Math.round(lot.partyPayable).toLocaleString()}</td>
                                                        <td>{lot.brokeragePercent}%</td>
                                                        <td className="text-end fw-bold text-success">+{Math.round(lot.brokerageAmount).toLocaleString()}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* TAB 2: PAYMENTS */}
                                    <div className="tab-pane fade" id="payments">
                                        {details.payments.length === 0 ? <p className="text-center text-muted mt-4">No payments made yet.</p> : (
                                            <table className="table table-sm table-hover small">
                                                <thead className="table-light"><tr><th>Date</th><th>Mode</th><th>Note</th><th className="text-end">Paid (₹)</th></tr></thead>
                                                <tbody>
                                                    {details.payments.map(p => (
                                                        <tr key={p._id}>
                                                            <td>{new Date(p.date).toLocaleDateString('en-GB')}</td>
                                                            <td>{p.mode}</td>
                                                            <td>{p.note || '-'}</td>
                                                            <td className="text-end fw-bold text-danger">-{Math.round(p.amount).toLocaleString()}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center p-5 text-muted bg-light rounded border border-dashed">
                            Select a Broker from the left to see their ledger.
                        </div>
                    )}
                </div>
            </div>

            {/* PAYMENT MODAL */}
            {showPayModal && (
                <div className="modal d-block" style={{backgroundColor:'rgba(0,0,0,0.5)'}}>
                    <div className="modal-dialog modal-sm modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header bg-success text-white">
                                <h6 className="modal-title">Pay {selectedBroker.name}</h6>
                                <button className="btn-close btn-close-white" onClick={() => setShowPayModal(false)}></button>
                            </div>
                            <form onSubmit={handlePayment}>
                                <div className="modal-body">
                                    <div className="mb-2">
                                        <label className="small">Amount</label>
                                        <input type="number" className="form-control" autoFocus required
                                            value={payForm.amount} onChange={e => setPayForm({...payForm, amount: e.target.value})} />
                                    </div>
                                    <div className="mb-2">
                                        <label className="small">Mode</label>
                                        <select className="form-select" value={payForm.mode} onChange={e => setPayForm({...payForm, mode: e.target.value})}>
                                            <option>Cheque</option><option>Cash</option>
                                        </select>
                                    </div>
                                    <div className="mb-2">
                                        <label className="small">Note</label>
                                        <input type="text" className="form-control" placeholder="Optional"
                                            value={payForm.note} onChange={e => setPayForm({...payForm, note: e.target.value})} />
                                    </div>
                                </div>
                                <div className="modal-footer p-1">
                                    <button className="btn btn-success btn-sm w-100">Confirm Payment</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BrokerLedger;